import { createFileRoute } from "@tanstack/react-router";

import { ConnectionsSettings } from "@/features/settings/ConnectionsSettings";

export const Route = createFileRoute("/_app/settings/connections")({
  component: ConnectionsSettings,
});
